import HomeRoute from "../../components/routes/HomeRoute";
import messages from "../../i18n/messages/fr.json";

export default function Page() {
  return <HomeRoute locale="fr" messages={messages} />;
}
